import * as Sentry from '@sentry/vue';
import { version } from '~~/package.json';

declare global {
  interface Sentry {
    any;
  }
  interface Window {
    Sentry: any;
  }
}

window.Sentry = Sentry;
globalThis.Sentry = Sentry;

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const {
    public: { sentry, appVersion },
  } = useRuntimeConfig();

  if (!sentry.dsn || !sentry.enable) {
    return {
      provide: {
        sentrySetContext: (...args) => {},
        sentrySetUser: (...args) => {},
        sentrySetTag: (...args) => {},
        sentryAddBreadcrumb: (...args) => {},
        sentryCaptureException: (...args) => {},
      },
    };
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentry.dsn,
    environment: sentry.environment,

    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets: [
          'localhost',
          'https://app.staging.nomadeducation.fr/',
          'https://app.nomadeducation.fr/',
        ],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      // new Sentry.Replay(),
    ],
    // Configure this whole part as you need it!
    tracesSampleRate: 0.2, // Change in prod
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled

    replaysSessionSampleRate: 1.0, // Change in prod
    replaysOnErrorSampleRate: 1.0, // Change in prod if necessary
    beforeSend(event, hint) {
      // Check if it is an exception, and if so, log it.
      if (event.exception) {
        if (
          event &&
          event.message &&
          event.message ===
            'ResizeObserver loop completed with undelivered notifications.'
        ) {
          return null;
        }

        globalThis.$logger.error(
          `[Exeption handled by Sentry]: (${hint.originalException})`,
          { event, hint }
        );
      }
      // Continue sending to Sentry
      return event;
    },
  });

  nuxtApp.vueApp.mixin(
    Sentry.createTracingMixins({
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
    })
  );
  Sentry.attachErrorHandler(nuxtApp.vueApp, {
    logErrors: false,
    attachProps: true,
    trackComponents: true,
    timeout: 2000,
    hooks: ['activate', 'mount', 'update'],
  });

  Sentry.setTag('app.version', version);

  Sentry.setTag('app.package.version', appVersion);

  return {
    provide: {
      sentrySetContext: Sentry.setContext,
      sentrySetUser: Sentry.setUser,
      sentrySetTag: Sentry.setTag,
      sentryAddBreadcrumb: Sentry.addBreadcrumb,
      sentryCaptureException: Sentry.captureException,
    },
  };
});
